import React from 'react';
import { Navigate } from 'react-router-dom';

const isAuthenticated = () => {
  // Same authentication check logic
  return localStorage.getItem('accessToken') !== null;
};

function RequireVisitor({ children }) {
  return !isAuthenticated() ? children : <Navigate to="/" replace />;
}

export default RequireVisitor;
